import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              <span>移动端</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-2">{appData.subtitle}</p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">{appData.description}</p>
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
              {appData.features.map((feat, idx) => (
                <span key={idx} className="px-3 py-1.5 rounded-full bg-background-50 border border-background-200/70 text-xs text-foreground-600 whitespace-nowrap">
                  <i className="ri-check-line text-primary-500 mr-1"></i>
                  {feat}
                </span>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 w-56 md:w-64">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/40 to-accent-200/40 rounded-[2rem] blur-lg"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20webtoon%20reading%20app%20interface%20on%20screen%2C%20modern%20minimal%20phone%20design%2C%20warm%20reading%20atmosphere%2C%20clean%20background%20with%20soft%20lighting%2C%20digital%20product%20photography%2C%20elegant%20presentation%2C%20coral%20and%20cream%20color%20scheme&width=600&height=900&seq=app-mobile-2026&orientation=portrait"
                alt="女神漫画移动端阅读体验"
                className="relative w-full rounded-[2rem] object-cover"
                style={{ aspectRatio: '2/3' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}